import { Spin, Progress, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { LoadingOutlined } from '@ant-design/icons';
import { SplashScreen } from '@shared/components/SplashScreen/SplashScreen';

const { Text } = Typography;

interface PageFallbackProps {
  message?: string;
  size?: 'small' | 'default' | 'large';
  showProgress?: boolean;
  progress?: number;
}

export function PageFallback({
  message,
  size = 'large',
  showProgress = false,
  progress,
}: PageFallbackProps) {
  const { t } = useTranslation(['translation']);

  const displayMessage = message || t('common.loading', 'Загрузка...');

  return (
    <div className="flex min-h-[200px] flex-col items-center justify-center py-10">
      {showProgress && progress !== undefined ? (
        <div className="flex flex-col items-center space-y-4">
          <Progress
            type="circle"
            percent={progress}
            size={size === 'large' ? 80 : size === 'default' ? 60 : 40}
            status={progress < 100 ? 'active' : 'success'}
          />
          <Text className="text-sm text-gray-500 dark:text-gray-300">
            {displayMessage}
          </Text>
        </div>
      ) : (
        <div className="flex flex-col items-center space-y-2">
          <Spin
            size={size}
            indicator={<LoadingOutlined style={{ fontSize: size === 'large' ? 24 : 16 }} spin />}
          />
          <Text className="text-sm text-gray-500 dark:text-gray-300">
            {displayMessage}
          </Text>
        </div>
      )}
    </div>
  );
}

// Брендовый сплэш-экран загрузки всего приложения «Крапива · V5».
// Делегирует на SplashScreen — единый источник брендового сплэша.
export function AppLoadingScreen() {
  return <SplashScreen />;
}


